/* eslint-disable react/no-array-index-key */
import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { Loader } from '../../../../components/Loader';
import { normalizeSearchString } from '../../../../utils/normalizeSearchString';
import { fetchKanbanBoardColumnCells, toggleKanbanCompanyModal } from '../../actions';

import { ADM_IN_1_crm_checks } from '../../cells/ADM/ADM_IN_1_crm_checks';
import { ApproveBVICell } from '../../cells/BVI/ApproveBVI';
import { BVIBotStep2 } from '../../cells/BVI/BVIBotStep2';
import { BVIErrors } from '../../cells/BVI/BVIErrors';
import { BVIRequestVehicleTransfer } from '../../cells/BVI/BVIRequestVehicleTransfer';
import { BVIStep2Complete } from '../../cells/BVI/BVIStep2Complete';
import { BVIStep2Error } from '../../cells/BVI/BVIStep2Error';
import { BVIUploadCell } from '../../cells/BVI/BVIUpload';
import { WS1_1_Labels } from '../../cells/WS/WS1_1_Labels';
import { WS1_2_CRM } from '../../cells/WS/WS1_2_CRM';
import { WS1_3_Keys } from '../../cells/WS/WS1_3_Keys';
import { WS1_4_TestDrive } from '../../cells/WS/WS1_4_TestDrive';
import { WS1_5_DamageCheck } from '../../cells/WS/WS1_5_DamageCheck';
import { WS1_6_Claim } from '../../cells/WS/WS1_6_Claim';
import { WS1_8_PreInspection } from '../../cells/WS/WS1_8_PreInspection';
import { WS2_10_ExteriorPictures } from '../../cells/WS/WS2_10_ExteriorPictures';
import { WS2_1_Interior } from '../../cells/WS/WS2_1_Interior';
import { WS2_2_clean } from '../../cells/WS/WS2_2_clean';
import { WS2_3_issue } from '../../cells/WS/WS2_3_issue';
import { WS2_6_InteriorPictures } from '../../cells/WS/WS2_6_InteriorPictures';
import { WS2_7_ExteriorInspection } from '../../cells/WS/WS2_7_ExteriorInspection';
import { WS2_9_exterior_edit } from '../../cells/WS/WS2_9_exterior_edit';
import { WS3_10_WindowRepair } from '../../cells/WS/WS3_10_WindowRepair';
import { WS3_11_Repair } from '../../cells/WS/WS3_11_Repair';
import { WS3_12_lock } from '../../cells/WS/WS3_12_lock';
import { ADM_OUT_0_tasks } from '../../cells/ADM/ADM_OUT_0_tasks';
import { ADM_IN_3_purchase_release } from '../../cells/ADM/ADM_IN_3_purchase_release';
import { WS3_1_PolishInterior } from '../../cells/WS/WS3_1_PolishInterior';
import { WS3_3_AttachRegplate } from '../../cells/WS/WS3_3_AttachRegplate';
import { WS3_4_InExtPolishInterior } from '../../cells/WS/WS3_4_InExtPolishInterior';
import { WS3_5_Adjust } from '../../cells/WS/WS3_5_Adjust';
import { WS3_6_DeSticker } from '../../cells/WS/WS3_6_DeSticker';
import { WS3_8_PlanAPK } from '../../cells/WS/WS3_8_PlanAPK';
import { WS3_9_PlanRecall } from '../../cells/WS/WS3_9_PlanRecall';
import { WS_Default } from '../../cells/WS/WS_Default';
import { WS_Plannable } from '../../cells/WS/WS_Plannable';
import { WS_FINAL_INSPECTION } from '../../cells/WS/WS_FINAL_INSPECTION';

import { selectKanbanBoardColumnCells, selectKanbanBoards, selectKanbanColumnSort } from '../../selectors';

import { Transport_1_nl_in } from '../../cells/Transport/Transport_1_nl_in';
import { IDWE_transport_nl_combine } from '../../cells/Transport/IDWE_transport_nl_combine';

import { IDWE_transport_in_nl_expected } from '../../cells/Transport/IDWE_transport_in_nl_expected';

import { Transport_in_eu } from '../../cells/Transport/Transport_in_eu';
import { Transport_out_eu } from '../../cells/Transport/Transport_out_eu';
import { Transport_eu_plan_intern } from '../../cells/Transport/Transport_eu_plan_intern';
import { Transport_plan_extern_outgoing_eu } from '../../cells/Transport/Transport_plan_extern_outgoing_eu';
import { Transport_plan_extern_incoming_eu } from '../../cells/Transport/Transport_plan_extern_incoming_eu';
import { Transport_1_nl_out } from '../../cells/Transport/Transport_1_nl_out';

import { IDWE_transport_nl_out_expected } from '../../cells/Transport/IDWE_transport_nl_out_expected';

import { IDWE_transport_nl_out_combined } from '../../cells/Transport/IDWE_transport_nl_out_combined';

import { Transport_plan_intern_outgoing } from '../../cells/Transport/Transport_plan_intern_outgoing';

import { Transport_1_plan_extern } from '../../cells/Transport/Transport_1_plan_extern';
import { Transport_1_takeout } from '../../cells/Transport/Transport_1_takeout';
import { COM_required_fields } from '../../cells/COM/COM_required_fields';
import { COM_sales_pref_import } from '../../cells/COM/COM_sales_pref_import';
import { COM_sales_prices } from '../../cells/COM/COM_sales_prices';
import { FIN_add_purchase_invoice } from '../../cells/FIN/FIN_add_purchase_invoice';
import { FIN_process_sale_import } from '../../cells/FIN/FIN_process_sale_import';
import { FIN_process_sales_2 } from '../../cells/FIN/FIN_process_sales_2';
import { FIN_factureren_1 } from '../../cells/FIN/FIN_factureren_1';
import { FIN_factureren_2 } from '../../cells/FIN/FIN_factureren_2';
import { FIN_factureren_3 } from '../../cells/FIN/FIN_factureren_3';
import { FIN_factureren_4 } from '../../cells/FIN/FIN_factureren_4';
import { FIN_factureren_5 } from '../../cells/FIN/FIN_factureren_5';
import { FIN_factureren_6 } from '../../cells/FIN/FIN_factureren_6';
import { FIN_final_invoice_no_mail } from '../../cells/FIN/FIN_final_invoice_no_mail';
import { IDWE_FIN_factureren_combine } from '../../cells/FIN/IDWE_FIN_factureren_combine';
import { IDWEFINfactureren_combine_akkoord } from '../../cells/FIN/IDWEFINfactureren_combine_akkoord';
import { Valideren_Niels } from '../../cells/COM/Valideren_Niels';
import { Valideren_Daley } from '../../cells/COM/Valideren_Daley';
import { Valideren_Gijs } from '../../cells/COM/Valideren_Gijs';
import { Valideren_Harrie } from '../../cells/COM/Valideren_Harrie';
import { Valideren_Jan } from '../../cells/COM/Valideren_Jan';
import { Valideren_Kai } from '../../cells/COM/Valideren_Kai';
import { Valideren_Marcel } from '../../cells/COM/Valideren_Marcel';
import { Valideren_Michiel } from '../../cells/COM/Valideren_Michiel';
import { Valideren_Nick } from '../../cells/COM/Valideren_Nick';
import { Valideren_Richard } from '../../cells/COM/Valideren_Richard';
import { Valideren_Sander } from '../../cells/COM/Valideren_Sander';
import { Valideren_Teun } from '../../cells/COM/Valideren_Teun';
import { Valideren_Gernand } from '../../cells/COM/Valideren_Gernand';
import { INKOOPVRIJWAREN_IJSSELDELTA } from '../../cells/ADM/INKOOPVRIJWAREN_IJSSELDELTA';
import { Transport_incoming_released_to_plan } from '../../cells/ADM/Transport_incoming_released_to_plan';

import { FIN_process_purchase } from '../../cells/FIN/FIN_process_purchase';
import { ADM_OUT_5_sales_release_ORB_STAGED } from '../../cells/ADM/ADM_OUT_5_sales_release_ORB_STAGED';
import { add_regplate_foreign } from '../../cells/ADM/add_regplate_foreign';
import { add_regplate_foreign_called } from '../../cells/ADM/add_regplate_foreign_called';
import { NL_KENTEKEN_AANGEVRAAGD_GEEN_BVI } from '../../cells/ADM/NL_KENTEKEN_AANGEVRAAGD_GEEN_BVI';
import { ADM_OUT_5_sales_release_tnd_sent } from '../../cells/ADM/ADM_OUT_5_sales_release_tnd_sent';
import { ADM_OUT_5_sales_release_called } from '../../cells/ADM/ADM_OUT_5_sales_release_called';
import { ADM_OUT_5_SALES_RELEASE_DONE_NO_UPDATE_VWE } from '../../cells/ADM/ADM_OUT_5_SALES_RELEASE_DONE_NO_UPDATE_VWE';
import { ADM_OUT_5_sales_export } from '../../cells/ADM/ADM_OUT_5_sales_export';

import { NL_KENTEKEN_AANVRAGEN_NEW_WAY } from '../../cells/ADM/NL_KENTEKEN_AANVRAGEN_NEW_WAY';
import { BPM_AANGIFTE_IMPORT_UITVOEREN } from '../../cells/ADM/BPM_AANGIFTE_IMPORT_UITVOEREN';
import { IDW_export_overview } from '../../cells/ADM/IDW_export_overview';

import { FIN_process_sale } from '../../cells/FIN/FIN_process_sale';
import { Transport_1_plan_intern_outgoing } from '../../cells/Transport/Transport_1_plan_intern_outgoing';
import { Transport_1_plan_intern } from '../../cells/Transport/Transport_1_plan_intern';
import { Transport_1_plan_extern_outgoing } from '../../cells/Transport/Transport_1_plan_extern_outgoing';
import { ADM_OUT_5_sales_release } from '../../cells/ADM/ADM_OUT_5_sales_release';
import { ADM_OUT_5_sales_release_not_home } from '../../cells/ADM/ADM_OUT_5_sales_release_not_home';

import { HOOI_check_auto } from '../../cells/HOOI/HOOI_check_auto';
import { HOOI_inslag } from '../../cells/HOOI/HOOI_inslag';
import { TEST_1 } from '../../cells/TEST/TEST_1';

import { COMPANY_EXAMPLE_1 } from '../../cells/Company/BASE_COMPANY_CELL';
import { req_fields_EU_in } from '../../cells/Company/req_fields_EU_in';
import { req_fields_EU_out } from '../../cells/Company/req_fields_EU_out';
import { req_fields_individual_in } from '../../cells/Company/req_fields_individual_in';
import { req_fields_individual_out } from '../../cells/Company/req_fields_individual_out';
import { req_fields_nl_in } from '../../cells/Company/req_fields_nl_in';
import { req_fields_nl_out } from '../../cells/Company/req_fields_nl_out';
import { req_fields_non_EU_in } from '../../cells/Company/req_fields_non_EU_in';
import { req_fields_non_EU_out } from '../../cells/Company/req_fields_non_EU_out';
import { acc_EU_in } from '../../cells/Company/acc_eu_in';
import { acc_EU_out } from '../../cells/Company/acc_eu_out';
import { acc_individual_in } from '../../cells/Company/acc_individual_in';
import { acc_individual_OUT } from '../../cells/Company/acc_individual_out';
import { acc_nl_in } from '../../cells/Company/acc_nl_in';
import { acc_nl_out } from '../../cells/Company/acc_nl_out';
import { acc_non_eu_in } from '../../cells/Company/acc_non_eu_in';
import { acc_non_eu_out } from '../../cells/Company/acc_non_eu_out';
import { BASE_USER_CELL } from '../../cells/User/BASE_USER_CELL';
import { BASE_INVOICE_CELL } from '../../cells/Invoice/BASE_INVOICE_CELL';
import { KanbanBoardColumnHeader } from './columnHeaderNijboer';
import { columnCellFilter } from '../../filters';
import { columnSorter } from '../../sort';
import { selectUserId } from '../../../Api/selectors';
import { TEST_2 } from '../../cells/TEST/TEST_2';
import { COUNTER_MAP } from '../../cells/WS/CounterMap';

import { BulkActionsCard } from '../../../Vehicles/pages/BulkActions/BulkActionsCard';
import { selectVehicleBulkActionsKanbanTaskName, selectVehicleBulkActionsList } from '../../../Vehicles/selectors';
import {
  addVehicleToBulkActionsList,
  getDocumentsByTypeByIds,
  removeVehicleFromBulkActionsList,
} from '../../../Vehicles/actions';
import { Button } from '../../../../components/Buttons';
import { Checkbox } from '../../../../components/Checkbox';
import { HBox } from '../../../../components/Box';
import { REQUIRES_COMPANY_NAME_PROPS } from '../../cells/CompanyNamesMap';
import { REQUIRES_ADDRESSES_PROPS } from '../../cells/AddressesMap';
import { fetchCompaniesByIds, fetchCompaniesPropertyByIds } from '../../../Companies/actions';
import { fetchAddressesByIds } from '../../../Address/actions';

const Container = styled.div`
  background-color: #f8f9fc;
  padding: 6px;
  border: 1px solid #e0e1eb;
  border-top: none;
  margin-right: 6px;
  min-width: ${props => (props.maxWidth ? '700px' : '300px')};
`;

const PLANNABLE = {
  WS4_1_PlanRestyle: { task_name: 'task_restyle' },
  WS4_2_PlanSpray: { task_name: 'task_spray' },
  WS4_3_PlanInterioPolish: { task_name: 'task_interior_polish' },
  WS4_4_PlanInteriorRepair: { task_name: 'task_interior_repair' },
  WS4_5_PlanSpotRepair: { task_name: 'task_spot_repair' },
  WS4_6_PlanDesticker: { task_name: 'task_desticker' },
  WS4_7_PlanWindowRepair: { task_name: 'task_window_repair' },
  WS4_8_PlanRepair: { task_name: 'task_repair' },
  WS4_9_PlanIntExtInterioPolish: { task_name: 'task_int_ext_polish' },
  WS4_10_PlanExtriorPolish: { task_name: 'task_polish_exterior' },
  WS4_11_PlanAdjust: { task_name: 'task_adjust' },
  WS3_8_PlanAPK: { task_name: 'task_apk' },
  WS3_2_PolishExterior: { task_name: 'task_polish_exterior' },
  WS3_7_PlanService: { task_name: 'task_service' },
  WS3_9_PlanRecall: { task_name: 'task_recall' },
  WS_plan_nijboer: { task_name: 'task_nijboer' },
  WS_plan_attach_parts: { task_name: 'task_attach_parts' },
  WS_plan_AVN: { task_name: 'task_AVN' },
};

const WITH_SIDE_MODAL_ACTIONS = [
  'COMPANY_EXAMPLE_1',
  'req_fields_EU_in',
  'req_fields_EU_out',
  'req_fields_individual_in',
  'req_fields_individual_out',
  'req_fields_nl_in',
  'req_fields_nl_out',
  'req_fields_non_EU_in',
  'req_fields_non_EU_out',
  'acc_EU_in',
  'acc_EU_out',
  'acc_individual_in',
  'acc_individual_OUT',
  'acc_nl_in',
  'acc_nl_out',
  'acc_non_eu_in',
  'acc_non_eu_out',
  'FIN_final_invoice_no_mail',
  'FIN_process_purchase',
  'FIN_factureren_1',
  'FIN_factureren_2',
  'FIN_factureren_3',
  'FIN_factureren_4',
  'FIN_factureren_5',
  'FIN_factureren_6',
];

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardColumnNijboerComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    if (this.vehicles?.length === this.props.bulkActionsList?.length) {
      this.setState({ allSelected: true });
    }
    this.props.fetch(res => {
      const ids = res?.cells?.filter(cell => cell.entityId || cell.vehicle?.id)?.map(c => c.entityId || c.vehicle?.id);
      ids?.length && this.props.getPhotos(ids);

      this.fetchCompanyNames(res?.cells);
      this.fetchAddresses(res?.cells);
      this.fetchCompanies(res?.cells);
    });
  }

  componentDidUpdate(prevState, prevProps) {
    if (this.vehicles?.length !== this.props.bulkActionsList?.length) {
      this.setState({ allSelected: false });
    }

    if (
      this.props.cells?.length &&
      (this.props.cells?.length !== prevProps.cells?.length || this.props.cells !== prevProps.cells)
    ) {
      const ids = this.props.cells?.filter(cell => cell.entityId || cell.vehicle?.id)?.map(c => c.entityId || c.vehicle?.id);
      ids?.length && this.props.getPhotos(ids);

      this.fetchCompanyNames(this.props.cells);
      this.fetchAddresses(this.props.cells);
      this.fetchCompanies(this.props.cells);
    }
  }

  get action() {
    return this.props.column.actions?.[0] || {};
  }

  get isCompanyAction() {
    return (this.props.column.actions?.[0] || {}).entity?.name === 'company';
  }

  get isUserAction() {
    return (this.props.column.actions?.[0] || {}).entity?.name === 'users';
  }

  get isInvoiceAction() {
    return (this.props.column.actions?.[0] || {}).entity?.name === 'invoice';
  }

  get sortedCells() {
    let cells = this.props.cells;
    return columnSorter(cells, this.props.sort);
  }

  get isMaxColumnWidth() {
    const actions = [
      'Transport_1_nl_in',
      'Transport_in_eu',
      'Transport_out_eu',
      'Transport_1_nl_out',
      'Transport_1_plan_intern',
      'IDWE_transport_in_nl_expected',
      'IDWE_transport_nl_out_combined',
      'IDWE_transport_nl_out_expected',
      'Transport_1_nl_in',
      'IDWE_transport_nl_combine',

      // 'Transport_eu_plan_intern',
      // 'Transport_plan_extern_outgoing_eu',
      // 'Transport_plan_extern_incoming_eu',
      // 'Transport_plan_intern_outgoing',
      'Transport_1_plan_intern_outgoing',
    ];
    return actions.includes(this.action?.functionName);
  }

  get sortedCells() {
    // let cells = this.props.cells;
    let cells = this.cells;
    let task = PLANNABLE[this.action.functionName]?.task_name;
    let counter_name;
    if (task) {
      counter_name = COUNTER_MAP[task];
    }

    return columnSorter(cells, this.props.sort, {
      counter_name,
    });
  }

  get cells() {
    if (this.isCompanyAction) {
      return _(this.props.cells)
        .filter(c => {
          if (!this.props.filter?.search || !c.company) return true;
          return c.company?.search?.indexOf(normalizeSearchString(this.props.filter.search)) > -1;
        })
        .map(c => {
          c.entityId = c?.company?.id;
          return c;
        })
        .value();
    }

    if (this.isUserAction) {
      return _(this.props.cells)
        .filter(c => {
          if (!this.props.filter?.search || !c.user) return true;
          return c.user?.search?.indexOf(normalizeSearchString(this.props.filter.search)) > -1;
        })
        .map(c => {
          c.entityId = c?.user?.id;
          return c;
        })
        .value();
    }

    return _(this.props.cells)
      .filter(c => {
        if (!this.props.filter?.search || !c.vehicle) return true;
        return c.vehicle?.search?.indexOf(normalizeSearchString(this.props.filter.search)) > -1;
      })
      .map(c => {
        c.entityId = c?.vehicle?.id;
        return c;
      })
      .value();
  }

  get vehicles() {
    return this.cells?.map(c => c.vehicle);
  }

  fetchCompanies(cells = []) {
    const REQUIRES_COMPANIES_PROPS = [{ cellClass: 'IDWE_BPM_geen_borg', propNames: ['invoice_outgoing_company_id'] }];
    const companyParams = REQUIRES_COMPANIES_PROPS.find(({ cellClass }) => this.action.functionName === cellClass);
    if (companyParams?.propNames?.length) {
      const companiesIdsMap = cells?.reduce((acc, cell) => {
        companyParams.propNames.forEach(propName => {
          const id = Number.parseInt(cell.vehicle?.[propName], 10);
          if (id) {
            acc[id] = id;
          }
        });

        return acc;
      }, {});

      const companiesIds = Object.values(companiesIdsMap || {});
      if (companiesIds.length) {
        this.props.fetchCompanies(companiesIds);
      }
    }
  }

  fetchAddresses(cells = []) {
    const addressParams = REQUIRES_ADDRESSES_PROPS.find(({ cellClass }) => this.action.functionName === cellClass);
    if (addressParams?.propNames?.length) {
      const addressesIdsMap = cells?.reduce((acc, cell) => {
        addressParams.propNames.forEach(propName => {
          const id = Number.parseInt(cell.vehicle?.[propName], 10);
          if (id) {
            acc[id] = id;
          }
        });

        return acc;
      }, {});

      const addressesIds = Object.values(addressesIdsMap || {});
      if (addressesIds.length) {
        this.props.getAddressesByIds(addressesIds);
      }
    }
  }

  fetchCompanyNames(cells = []) {
    const companyParams = REQUIRES_COMPANY_NAME_PROPS.find(({ cellClass }) => this.action.functionName === cellClass);
    if (companyParams?.propNames?.length) {
      const companiesIdsMap = cells?.reduce((acc, cell) => {
        companyParams.propNames.forEach(propName => {
          const id = Number.parseInt(cell.vehicle?.[propName], 10);
          if (id) {
            acc[id] = id;
          }
        });

        return acc;
      }, {});

      const companiesIds = Object.values(companiesIdsMap || {});
      if (companiesIds.length) {
        this.props.getCompaniesNamesByIds(companiesIds, 'name');
      }
    }
  }

  getCellClass() {
    if (this.isCompanyAction) {
      let result = this.getCompanyCellClass();
      if (result) return result;
    }

    if (this.isUserAction) {
      let result = this.getUserCellClass();
      if (result) return result;
    }

    if (this.isInvoiceAction) {
      let result = this.getInvoiceCellClass();
      if (result) return result;
    }

    return this.getVehicleCellClass();
  }

  getVehicleCellClass() {
    let Class = {
      approveBVIContent: ApproveBVICell,
      BVIRequestVehicleTransfer,
      bviBotStep2: BVIBotStep2,
      BVIErrors,
      BVIUpload: BVIUploadCell,
      BVIStep2Error,
      BVIStep2Complete,
      WS1_8_PreInspection,
      WS1_1_Labels,
      WS1_2_CRM,
      WS1_3_Keys,
      WS1_4_TestDrive,
      WS1_5_DamageCheck,
      WS1_6_Claim,
      ///ws 2
      WS2_1_Interior,
      WS2_2_clean,
      WS2_3_issue,
      WS2_6_InteriorPictures,
      WS2_7_ExteriorInspection,
      WS2_9_exterior_edit,
      WS2_10_ExteriorPictures,
      //ws 3
      WS3_1_PolishInterior,
      WS3_3_AttachRegplate,
      WS3_4_InExtPolishInterior,
      WS3_5_Adjust,
      WS3_6_DeSticker,
      WS3_8_PlanAPK,
      WS3_9_PlanRecall,
      WS3_10_WindowRepair,
      WS3_11_Repair,
      WS3_12_lock,
      WS_FINAL_INSPECTION,

      //ADM IN
      ADM_IN_1_crm_checks,
      INKOOPVRIJWAREN_IJSSELDELTA,

      //ADM OUT
      ADM_OUT_0_tasks,
      ADM_OUT_5_sales_release,
      ADM_OUT_5_sales_release_not_home,
      ADM_OUT_5_sales_release_ORB_STAGED,
      ADM_OUT_5_sales_release_tnd_sent,
      ADM_OUT_5_sales_release_called,
      ADM_OUT_5_SALES_RELEASE_DONE_NO_UPDATE_VWE,
      ADM_OUT_5_sales_export,
      add_regplate_foreign,
      add_regplate_foreign_called,
      NL_KENTEKEN_AANGEVRAAGD_GEEN_BVI,
      NL_KENTEKEN_AANVRAGEN_NEW_WAY,
      BPM_AANGIFTE_IMPORT_UITVOEREN,
      IDW_export_overview,
      ADM_IN_3_purchase_release,
      Transport_incoming_released_to_plan,

      //transport
      Transport_1_nl_in,
      Transport_in_eu,
      Transport_out_eu,
      IDWE_transport_in_nl_expected,
      IDWE_transport_nl_combine,

      Transport_1_nl_out,
      Transport_1_plan_intern,
      Transport_eu_plan_intern,
      Transport_plan_extern_outgoing_eu,
      Transport_plan_extern_incoming_eu,
      Transport_plan_intern_outgoing,
      IDWE_transport_nl_out_combined,
      IDWE_transport_nl_out_expected,

      Transport_1_plan_extern,
      Transport_1_plan_extern_outgoing,
      Transport_1_takeout,
      Transport_1_plan_intern_outgoing,

      //commercial
      COM_required_fields,
      COM_sales_pref_import,
      COM_sales_prices,
      FIN_add_purchase_invoice,
      FIN_factureren_1,
      FIN_factureren_2,
      FIN_factureren_3,
      FIN_factureren_4,
      FIN_factureren_5,
      FIN_factureren_6,
      FIN_process_sale_import,
      FIN_process_sale,
      FIN_final_invoice_no_mail,
      FIN_process_purchase,
      TEST_1,
      TEST_2,
      FIN_process_sales_2,
      IDWEFINfactureren_combine_akkoord,
      IDWE_FIN_factureren_combine,

      //Commercieel
      Valideren_Niels,
      Valideren_Daley,
      Valideren_Gernand,
      Valideren_Gijs,
      Valideren_Harrie,
      Valideren_Jan,
      Valideren_Kai,
      Valideren_Marcel,
      Valideren_Michiel,
      Valideren_Nick,
      Valideren_Richard,
      Valideren_Sander,
      Valideren_Teun,

      //HOOI
      HOOI_check_auto,
      HOOI_inslag,
    }[this.action.functionName];

    let payload = {};

    if (!Class) {
      if (this.action.functionName?.indexOf('WS') === 0) {
        Class = WS_Default;
      } else {
        Class = WS_Default;
      }
    }

    if (this.action.functionName in PLANNABLE) {
      Class = WS_Plannable;
    }

    return Class;
  }

  getCompanyCellClass() {
    // return BASE_COMPANY_CELL;

    let Class = {
      COMPANY_EXAMPLE_1,
      req_fields_EU_in,
      req_fields_EU_out,
      req_fields_individual_in,
      req_fields_individual_out,
      req_fields_nl_in,
      req_fields_nl_out,
      req_fields_non_EU_in,
      req_fields_non_EU_out,
      acc_EU_in,
      acc_EU_out,
      acc_individual_in,
      acc_individual_OUT,
      acc_nl_in,
      acc_nl_out,
      acc_non_eu_in,
      acc_non_eu_out,
    }[this.action.functionName];

    if (!Class) {
      console.log(this.action.functionName);
      debugger;
    }
    return Class;
  }

  getUserCellClass() {
    return BASE_USER_CELL;
  }

  getInvoiceCellClass() {
    return BASE_INVOICE_CELL;
  }

  getCellPayload(cellClass) {
    let payload = {};

    if (this.action.functionName in PLANNABLE) {
      payload = PLANNABLE[this.action.functionName];
    }

    //add counter names ...

    return payload;
  }

  onCloseCompanyModal(e) {
    if (e.target !== e.currentTarget) return;
    if (WITH_SIDE_MODAL_ACTIONS.includes(this.action.functionName)) {
      return this.props.onCloseModal();
    }
    return;
  }

  get isBulkActionColumn() {
    return [
      'Transport_in_eu',
      'Transport_out_eu',
      'IDWE_transport_in_nl_expected',
      'IDWE_transport_in_DLA24',
      'Transport_1_nl_in',
      'IDWE_transport_nl_out_combined',
      'IDWE_transport_nl_individual',
    ].includes(this.action?.functionName);
  }

  renderBulkActionSelector() {
    return (
      <Checkbox
        checked={this.state.allSelected == '1' && this.props.bulkActionTask == this.action.functionName}
        onChange={e => {
          if (this.state.allSelected == '1') {
            this.setState({ allSelected: '0' });
            return this.onRemoveAll(e, this.vehicles);
          }
          this.setState({ allSelected: '1' });
          return this.onSelectAll(e, this.vehicles, this.action.functionName);
        }}
      />
    );
  }

  onSelectAll(e, vehicles, taskName) {
    e.stopPropagation();

    if (vehicles?.length) {
      return this.props.addVehicleToBulkActionsList(vehicles, taskName);
    }
    return;
  }

  onRemoveAll(e, vehicles) {
    e.stopPropagation();
    return vehicles?.filter(vehicle => this.props.removeVehicleFromBulkActionsList(vehicle?.id));
  }

  render() {
    if (this.props.work) return <Loader small />;

    let Class = this.getCellClass();
    if (!Class) return null;

    const cells = this.sortedCells;
    if (this.props.hideOnEmpty && !cells?.length) return null;

    let payload = this.getCellPayload(Class);

    return (
      <Container maxWidth={this.isMaxColumnWidth} onClick={this.onCloseCompanyModal.bind(this)}>
        {!!this.props.bulkActionsList?.length && <BulkActionsCard bulkActionsList={this.props.bulkActionsList} />}
        <KanbanBoardColumnHeader
          isCompanyAction={this.isCompanyAction}
          loggedUserId={this.props.loggedInUserId}
          payload={payload}
          onChange={this.props.onChange}
          action={this.action}
          actionClass={Class}
          board_id={this.props.board_id}
          column={this.props.column}
          label={
            <>
              {this.isBulkActionColumn && this.renderBulkActionSelector()}
              {this.props.column.label}&nbsp;({cells.length})
            </>
          }
        />
        {cells?.map((cell, index) => (
          <Class
            key={`${cell.entityId}-${index}`}
            cell={cell}
            board_id={this.props.board_id}
            onChange={this.props.onChange}
            action={this.action}
            column={this.props.column}
            payload={payload}
            loggedUserId={this.props.loggedInUserId}
            loadSingleRes={false}
          >
            {cell.regplate}
          </Class>
        ))}
      </Container>
    );
  }
}

KanbanBoardColumnNijboerComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    boards: selectKanbanBoards(),
    cells: selectKanbanBoardColumnCells(ownProps.boards_id, ownProps.column.id),
    sort: selectKanbanColumnSort(ownProps.column.id),
    loggedInUserId: selectUserId(),
    bulkActionsList: selectVehicleBulkActionsList(),
    bulkActionTask: selectVehicleBulkActionsKanbanTaskName(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(cb) {
      dispatch(fetchKanbanBoardColumnCells(ownProps.board_id, ownProps.column.id, cb));
    },
    getPhotos(ids, callback) {
      dispatch(getDocumentsByTypeByIds(ids, 'photo_interior_general_0left_front', callback));
    },
    getAddressesByIds(ids, cb) {
      dispatch(fetchAddressesByIds(ids, cb));
    },
    getCompaniesNamesByIds(ids, propertyName, cb) {
      dispatch(fetchCompaniesPropertyByIds(ids, propertyName, cb));
    },
    fetchCompanies(companyIds) {
      dispatch(fetchCompaniesByIds(companyIds));
    },
    addVehicleToBulkActionsList(vehicles, taskName) {
      dispatch(addVehicleToBulkActionsList(null, vehicles, taskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
    onCloseModal() {
      dispatch(toggleKanbanCompanyModal());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardColumnNijboer = compose(withConnect, withRouter)(KanbanBoardColumnNijboerComp);
